export function calculateAge(date1, date2) {
  var year = 1000 * 60 * 60 * 24 * 365;
  var diff = Math.abs(date1.getTime() - date2.getTime());
  return Math.floor(diff / year);
}
export function calculateAgeForHost(host) {
  var now = new Date();
  var birth = new Date(host.birthday.date);
  return calculateAge(now, birth);
}